import { NumberInput, Stack, Text } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectAutoPipeRoutingBlockedRoomFactor,
  selectAutoPipeRoutingCorridorRoomFactor,
  selectAutoPipeRoutingPerimeterPenaltyFactor,
  selectAutoPipeRoutingRoomCrossingPenaltyM,
  selectAutoPipeRoutingVerticalPenaltyFactor,
  setAutoPipeRoutingBlockedRoomFactorInRedux,
  setAutoPipeRoutingCorridorRoomFactorInRedux,
  setAutoPipeRoutingPerimeterPenaltyFactorInRedux,
  setAutoPipeRoutingRoomCrossingPenaltyMInRedux,
  setAutoPipeRoutingVerticalPenaltyFactorInRedux,
} from "../../pipeRoutingSlice";

export const AutoPipeRoutingCostSettingsStep = () => {
  const dispatch = useAppDispatch();
  const roomCrossingPenaltyM = useAppSelector(selectAutoPipeRoutingRoomCrossingPenaltyM);
  const corridorRoomFactor = useAppSelector(selectAutoPipeRoutingCorridorRoomFactor);
  const blockedRoomFactor = useAppSelector(selectAutoPipeRoutingBlockedRoomFactor);
  const verticalPenaltyFactor = useAppSelector(selectAutoPipeRoutingVerticalPenaltyFactor);
  const perimeterPenaltyFactor = useAppSelector(selectAutoPipeRoutingPerimeterPenaltyFactor);

  return (
    <Stack gap="sm">
      <Text size="sm" c="dimmed">
        Finjuster hvordan roralgoritmen vekter romkryssinger, vertikal kostnad og nærhet til
        perimeter.
      </Text>

      <NumberInput
        label="Penalty for romkryssing (m)"
        value={roomCrossingPenaltyM}
        min={0}
        step={0.1}
        decimalScale={2}
        onChange={(value) => {
          if (typeof value !== "number") return;
          dispatch(setAutoPipeRoutingRoomCrossingPenaltyMInRedux(value));
        }}
      />

      <NumberInput
        label="Korridor-faktor"
        description="Skalerer alle kostnader (distanse, retningsskift, romkryssing) i korridor, forrom, sluse og vestibyle. Under 1 favoriserer korridorer."
        value={corridorRoomFactor}
        min={0}
        step={0.05}
        decimalScale={2}
        onChange={(value) => {
          if (typeof value !== "number") return;
          dispatch(setAutoPipeRoutingCorridorRoomFactorInRedux(value));
        }}
      />

      <NumberInput
        label="Blokkert rom-faktor"
        description="Skalerer alle kostnader i blokkerte rom (heis og lignende). Høy verdi gjør at rør unngår disse rommene."
        value={blockedRoomFactor}
        min={1}
        step={10}
        decimalScale={0}
        onChange={(value) => {
          if (typeof value !== "number") return;
          dispatch(setAutoPipeRoutingBlockedRoomFactorInRedux(value));
        }}
      />

      <NumberInput
        label="Vertikal penalty-faktor"
        value={verticalPenaltyFactor}
        min={0}
        step={0.1}
        decimalScale={2}
        onChange={(value) => {
          if (typeof value !== "number") return;
          dispatch(setAutoPipeRoutingVerticalPenaltyFactorInRedux(value));
        }}
      />

      <NumberInput
        label="Perimeter penalty-faktor"
        description="Lavere enn 1 favoriserer perimeter/fasad, hoyere enn 1 skyver ror bort."
        value={perimeterPenaltyFactor}
        min={0}
        step={0.1}
        decimalScale={2}
        onChange={(value) => {
          if (typeof value !== "number") return;
          dispatch(setAutoPipeRoutingPerimeterPenaltyFactorInRedux(value));
        }}
      />
    </Stack>
  );
};
